import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { School } from '@/types/school';

export const getChildSchools = async (
  line_id: string,
  accessToken: string,
  child_id: number
): Promise<ApiResult<School[]>> => {
  const { status, result } = await callApiWithoutToken<School[]>(
    `line/${line_id}/children/${child_id}/schools`,
    'GET',
    accessToken,
    undefined
  );
  return { status, result };
};
